<template>
  <v-container
    fluid
    fill-height
  >
    <v-layout
      align-center
      justify-center
    >
      <v-flex
        xs12
        sm8
        md6
      >
        <h1 style="text-align:center;font-weight:300;font-size:36px;">
          {{ app_name }}
        </h1>
        <div style="text-shadow: 3px 3px 4px #000;margin-left: -50px;font-family: Roboto; font-weight:900;font-size: 18em;letter-spacing: -35px;text-align:center;-webkit-text-stroke: 1px white;">
          404
        </div>
        <v-alert
          value="true"
          type="warning"
        >
          The page you were looking for can't be found. Check the link you followed and try again.
        </v-alert>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Error404'
}
</script>
